import Form from '@/found/components/form';
import request from '@/found/utils/request';
import detailsList from './details_list.vue';

formCreate.component('detailList', detailsList);
export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formFunctionCode: 'addForm',
      formParentCode: 'CRM20250926000000003',
      baseUnit: [],
      buttonText: {
        submit: '提交',
        close: '关闭',
        submitAudit: '暂存',
      },
      buttons: {
        submit: true,
        close: true,
        loading: false,
        submitAudit: true,
      },
    };
  },
  created() {

  },
  methods: {

    // 设置rule
    setRule(item) {
      const v = item;

      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      console.log('表单渲染完成', this.formConfig);
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        request.post('/tpm/tpmawardtransform/query', {
          id: this.formConfig.row.id,
        }).then((res) => {
          this.setValue({
            ...res.result,
            detailList: {
              listTwo: res.result.feeBudgetList || [],
              listOne: res.result.detailList || [],
            },
          });
        });
      }
    },
    // 提交
    submit(e) {
      const formData = this.getFormData(); // 获取表单的值
      console.log(formData);
      console.log(e);
      let url = '';

      if (formData) {
        const params = {
          fileList: formData.fileList || [],
          zcFlag: e === 2 ? 'Y' : 'N',
          remarks: formData.remarks || '',
          detailList: formData.detailList.listOne || [],
        };
        url = '/tpm/tpmawardtransform/save';

        if (this.formConfig.code === 'edit') {
          url = '/tpm/tpmawardtransform/update';
          params.id = this.formConfig.row.id;
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
